module.exports = __webpack_public_path__ + "static/04-c0e5e17457a2971e33f6ecdee2c98aaf.jpg";